import React from 'react';
import '../css/style.css';

function About() {
  return (
    <div className="container">
      <h1 className="section-title">About Me</h1>
      <div className="row">
        <div className="col-lg-8">
          <p className="lead">
            I am a Security Engineer with a strong focus on detection engineering, incident response, and security operations.
            Currently pursuing my Master's in Computer Science at UC San Diego, I combine academic excellence with practical experience
            in the cybersecurity industry.
          </p>

          <div className="mt-5">
            <h2 className="h3 mb-4">Core Competencies</h2>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">🛡️ Security Operations & Incident Response</li>
                  <li className="mb-3">🔍 Detection Engineering</li>
                  <li className="mb-3">🌐 Cloud Security (AWS, Azure, GCP)</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">🔐 Threat Intelligence</li>
                  <li className="mb-3">⚡ Security Automation</li>
                  <li className="mb-3">📊 Security Analytics</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <h2 className="h3 mb-4">Professional Journey</h2>
            <p>
              Through my roles at Sigma Computing and Deloitte, I've developed and implemented security solutions that have
              significantly improved organizational security postures. Key achievements include:
            </p>
            <ul>
              <li>Designed automated CTI pipeline processing 100K+ IOCs daily</li>
              <li>Reduced false positives by 20% through custom detection implementation</li>
              <li>Led rapid incident response efforts protecting 200+ endpoints</li>
            </ul>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title">Quick Facts</h3>
              <ul className="list-unstyled">
                <li className="mb-3">📚 MS in Computer Science at UC San Diego</li>
                <li className="mb-3">🎓 B.Tech in Computer Science</li>
                <li className="mb-3">💼 Security Engineering Intern at Sigma Computing</li>
                <li className="mb-3">🌟 Former Security Operations Analyst at Deloitte</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
